import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { finalize } from 'rxjs/operators';
import { RequestLoaderService } from './request-loader.service';

@Injectable()
export class RequestLoaderInterceptor implements HttpInterceptor {
  private readonly loaderService = inject(RequestLoaderService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.params.get('skipLoaderLock')) {
      return next.handle(req);
    }

    const lockScreen = req.params.get('lockScreen');
    this.loaderService.show(!!lockScreen);

    return next.handle(req).pipe(
      finalize(() => {
        this.loaderService.hide();
      }),
    );
  }
}
